import requests from "./httpService";

const SubscribeServices = {
  getAllSubscribe: async () => {
    return requests.get(`/subscribe/`);
  }
  // getAlljobrole: async () => {
  //   return requests.get(`/subscribe/`);
  // }
};

export default SubscribeServices;
